module.exports = __webpack_public_path__ + "static/10-vortex-illusion-945ccbd46bfb1aa17a190945f54f463e.png";